module.exports = __webpack_public_path__ + "static/media/ubuntu.5f152b87.svg";